import React, { useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Dialog from 'Components/UI/Dialog';
import useMobileLayout from 'Hooks/useMobileLayout';
import classNames from 'classnames';
import MaterialDialogContent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogContent';
import ScheduleSendSelector from 'Components/Modals/ScheduleSendDatePicker/ScheduleSendSelector';
import ScheduleSendDateSelector from 'Components/Modals/ScheduleSendDatePicker/ScheduleSendDateSelector';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { noop } from 'Helpers/PropTypes';

const styles = (theme) => ({
  paper: {
    width: '100%',
  },
  root: {
    padding: theme.spacing(0),
    '&:first-child': {
      padding: theme.spacing(0),
    },
  },
  dialogContainer: {
    color: theme.palette.facet.primaryBlue,
  },
  header: {
    margin: theme.spacing(3),
  },
  title: {
    fontWeight: 'bold',
  },
  optionList: {},
  option: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1, 3),
    '&:hover': {
      backgroundColor: theme.palette.facet.lightGray3,
    },
  },
  optionPrompt: {
    display: 'flex',
    flex: 1,
  },
  optionDate: {
    display: 'flex',
    flex: 1,
  },
  selected: {
    backgroundColor: theme.palette.facet.lightGray3,
  },
  buttonBarContainer: {
    padding: theme.spacing(0, 2),
  },
  buttonBar: {
    display: 'flex',
    flexDirection: 'row',
    borderTop: '1px solid',
    borderTopColor: theme.palette.facet.accentGray,
    padding: theme.spacing(1, 0, 2, 0),
  },
  datePicker: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: theme.palette.facet.lightGray3,
    },
    border: '0px solid',
    borderRadius: '10px',
    padding: theme.spacing(1),
  },
  datePickerIcon: {
    paddingRight: theme.spacing(0.25),
  },
  confirmationButton: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
  },
});

const ScheduleSendDatePicker = ({
  classes,
  isOpen,
  closeModal,
  meetingResource,
  meetingAgendaResource,
  onSubmit,
}) => {
  const currentMeetingAgenda = meetingResource ? meetingResource.attr('agendas')?.resources().last() : meetingAgendaResource;
  const isMobile = useMobileLayout();
  const [selectedOption, setSelectedOption] = useState(null);
  const [datePickerIsOpen, setDatePickerIsOpen] = useState(false);

  const handlePickDateTime = async (dateTime, type) => {
    // const newestMeetingAgendaResource = meetingAgendaResource;
    // if (meetingResource) {
    //   const meetingAgendaCollection = await meetingResource.relationship(fr.relationships.meetingAgendas.name).link('related').get();
    //   newestMeetingAgendaResource = meetingAgendaCollection.resources().last();
    // }
    meetingAgendaResource.attr('scheduledSendType', type);
    meetingAgendaResource.attr('scheduledSendCustomDate', dateTime.format());

    try {
      onSubmit(meetingAgendaResource.copy());
    } catch (err) {
      displayErrorMessage(err, err.errors);
      return;
    }
    setDatePickerIsOpen(false);
  };

  const handleClose = (e) => {
    if (datePickerIsOpen) {
      setDatePickerIsOpen(false);
    } else {
      closeModal(e);
    }
  };

  if (meetingResource && meetingAgendaResource) {
    throw new Error('Should only have a meeting or a meeting agenda, not both.');
  }
  return (
    <Dialog
      fullScreen={isMobile}
      onClose={handleClose}
      open={isOpen}
      maxWidth="sm"
    >
      <MaterialDialogContent
        className={classNames(classes.root)}
      >
        {!datePickerIsOpen && (
        <ScheduleSendSelector
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
          setDatePickerIsOpen={setDatePickerIsOpen}
          meetingAgenda={currentMeetingAgenda}
          handlePickDateTime={handlePickDateTime}
        />
        )}
        {datePickerIsOpen && (
        <ScheduleSendDateSelector
          handlePickDateTime={handlePickDateTime}
          currentDate={moment(currentMeetingAgenda.attr('scheduledSendCustomDate'))}
        />
        )}
      </MaterialDialogContent>
    </Dialog>
  );
};

ScheduleSendDatePicker.defaultProps = {
  meetingResource: null,
  meetingAgendaResource: null,
  onSubmit: noop,
};

ScheduleSendDatePicker.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  meetingResource: PropTypes.object,
  meetingAgendaResource: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default withStyles(styles)(ScheduleSendDatePicker);
